import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
	menulist: {
		padding: '8px',
		'& > *': {
			borderRadius: 1,
		},
	},
	paperClass: {
		width: '250px',
	},
	menuItem: {
		display: 'flex',
		width: '100%',
		// padding: '0px 0px 5px 0px',
		paddingLeft: '0px',
	},
	typography: {
		display: 'flex',
		marginLeft: '5px',
	},
}));

export default styles;
